import Https from './Https';

export default Https;
